import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import {MenuItem} from '@components';
import * as mainService from '@app/services/mainService';
import {loadMenu} from '@store/reducers/auth';

/*
function RawMenuFunc() {
    const rawmyMenu = MENU.map((menuItem) => (
        <MenuItem key={menuItem.name} menuItem={menuItem} />
    ));
    return rawmyMenu;
}
*/

const MenuSidebar = () => {

    const dispatch = useDispatch();
    const [myMenu, setMyMenu] = useState([]);

    /*useEffect(async () => {
        let isMounted = true;
        const myMenuX =  await mainService.showLeftMenu(); //MENU;
        console.log(myMenuX);
        if(isMounted && myMenuX)
        {
            dispatch(loadMenu(myMenuX));
            setMyMenu(myMenuX);
        }
        return () => { isMounted = false };
    }, []);*/

    useEffect(async () => {
        const myMenuX =  await mainService.showLeftMenu(); //MENU;
        if(myMenuX)
        {
            dispatch(loadMenu(myMenuX));
            const rawmyMenu = myMenuX.map((menuItem) => (
                <MenuItem key={menuItem.id} menuItem={menuItem} />
            ));
            setMyMenu(rawmyMenu);
        }

    }, []);

    if(!myMenu)
    {
        return  null;
    }
    return (
        <aside className="main-sidebar sidebar-dark-primary elevation-4">
            <Link to="/" className="brand-link">
                <img
                    src={ process.env.PUBLIC_URL +"/img/flower.png" }
                    alt="AdminLTE Logo"
                    className="brand-image img-circle elevation-3"
                    style={{opacity: '.8'}}
                />
                <span className="brand-text font-weight-light">STANDARD SYS</span>
            </Link>
            <div className="sidebar">
                {/*<div className="user-panel mt-3 pb-3 mb-3 d-flex">
                    <div className="image">
                        <img
                            src={user.picture || '/img/default-profile.png'}
                            className="img-circle elevation-2"
                            alt="User"
                        />
                    </div>
                    <div className="info">
                        <Link to="/profile" className="d-block">
                            {user.email}
                        </Link>
                    </div>
                </div>*/}
                <nav className="mt-2" style={{overflowY: 'hidden'}}>
                    <ul
                        className="nav nav-pills nav-sidebar flex-column"
                        role="menu"
                    >
                        {/*{
                            myMenu && myMenu.map((menuItem) => (
                                <MenuItem key={menuItem.id} menuItem={menuItem} />
                            ))
                        }*/}
                        {myMenu}
                    </ul>
                </nav>
            </div>
        </aside>
    );
};

export default MenuSidebar;
